import {attributeHistoryRuleDefaults} from './defaults';
import type {AttributeHistoryRule} from './types';

type CreateAttributeHistoryRuleParams = {
	attributeId: number;
	attributeValue: string;
};

export const createAttributeHistoryRule = ({
	attributeId,
	attributeValue,
}: CreateAttributeHistoryRuleParams): AttributeHistoryRule => ({
	...attributeHistoryRuleDefaults,
	elementValue1: attributeId,
	elementValue2: attributeValue,
});

export default createAttributeHistoryRule;
